var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ejs-toolbar",
    { attrs: { id: "customToolbar" } },
    [
      _c(
        "e-items",
        [
          _c("e-item", {
            attrs: {
              id: "closePage",
              prefixIcon: _vm.icons.close,
              tooltipText: _vm.texts.close,
              click: _vm.closeViewerEvent,
            },
          }),
          _c("e-item", {
            attrs: {
              id: "previousPage",
              prefixIcon: _vm.icons.previousArrow,
              tooltipText: _vm.texts.previousPage,
              align: "Center",
              cssClass: _vm.checkIfPreviousArrowIsDisabled,
              click: _vm.previousClicked,
            },
          }),
          _c("e-item", {
            attrs: {
              id: "nextPage",
              prefixIcon: _vm.icons.nextArrow,
              tooltipText: _vm.texts.nextPage,
              align: "Center",
              cssClass: _vm.checkIfNextArrowIsDisabled,
              click: _vm.nextClicked,
            },
          }),
          _c("e-item", {
            attrs: { template: _vm.numberOfPagesTemplate, align: "Center" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }